export const dashboardRightStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
};
